import React, { useState, useContext, useEffect } from "react";
import { InfoContext } from "../../InfoContext";
import { AuthContext } from "../../AuthContext";
import GroupManageCard from "../components/GroupManageCard";
import GroupMatchesCard from "../components/GroupMatchesCard";
import { Group } from "../../InfoContext";
import { UserContext } from "../../UserContext";

const Matches: React.FC = () => {
  const [selectedSeasonId, setSelectedSeasonId] = useState("");

  const { role } = useContext(AuthContext);
  const { seasons, getSeasonById } = useContext(InfoContext);
  const { user } = useContext(UserContext);
  useEffect(() => {
    if (seasons.length > 0) {
      const maxId = Math.max(
        ...seasons
          .filter((season) => season.groups.length > 0)
          .map((season) => season.id)
      );
      setSelectedSeasonId(String(maxId));
    }
  }, [seasons]);

  const selectedSeasonIdInt = parseInt(selectedSeasonId, 10);
  const selectedSeason = getSeasonById(selectedSeasonIdInt);
  const sortedGroups = selectedSeason?.groups.sort((a, b) => a.id - b.id) || [];

  if (role === "USER") {
    return (
      <div className="text-white">
        Please join or create a team to see your matches!
      </div>
    );
  }
  const getUserGroup = (groupId: number): Group | undefined => {
    return selectedSeason?.groups.find(
      (group) =>
        group.id === groupId &&
        group.teams.some((team) => team.id === user?.member_of)
    );
  };
  let groupMatches = selectedSeason?.matches || [];
  if (role !== "ADMIN") {
    const group = selectedSeason?.groups.find((group) =>
      getUserGroup(group.id)
    );

    groupMatches =
      selectedSeason?.matches.filter(
        (match) =>
          match.match_stage === group?.name.replace(/\s/g, "").toUpperCase()
      ) || [];
  }

  return (
    <div className="flex flex-col justify-start items-center w-full h-full overflow-y-auto p-4 gap-y-4">
      <form className="flex flex-col text-black bg-white rounded-xl shadow-md w-full max-w-32 gap-y-4">
        <select
          id="seasonSelect"
          value={selectedSeasonId}
          onChange={(e) => setSelectedSeasonId(e.target.value)}
          className="w-full px-3 py-2 border rounded-xl "
          required
        >
          {seasons.map((season) => (
            <option key={season.id} value={season.id}>
              {season.name}
            </option>
          ))}
        </select>
      </form>
      {selectedSeason?.groups.map((group) => (
        <GroupManageCard
          key={group.id}
          group={group}
          season_id={selectedSeasonIdInt}
        />
      ))}
      {selectedSeason?.groups.length === 0 && (
        <div className="bg-white/10 rounded-xl p-4 text-white max-w-3xl w-full">
          <h3 className="text-2xl font-bold">Group ...</h3>
          <p>This Season has no groups yet, please create some!</p>
        </div>
      )}
      <div className=" text-white max-w-3xl w-full grid grid-cols-1 gap-x-2 gap-y-4">
        {sortedGroups.map((group, index) => {
          return (
            <GroupMatchesCard
              key={group.id}
              groupName={`Group ${index + 1}`}
              matches={groupMatches}
            />
          );
        })}
        <GroupMatchesCard
          groupName={"Quarterfinal"}
          matches={
            selectedSeason?.matches.filter((match) =>
              match.match_stage.startsWith("QUARTERFINAL")
            ) || []
          }
        />

        <GroupMatchesCard
          groupName={"Semifinal"}
          matches={
            selectedSeason?.matches.filter((match) =>
              match.match_stage.startsWith("SEMIFINAL")
            ) || []
          }
        />

        <GroupMatchesCard
          groupName={"Place 3"}
          matches={
            selectedSeason?.matches.filter((match) =>
              match.match_stage.startsWith("PLACE3")
            ) || []
          }
        />

        <GroupMatchesCard
          groupName={"Final"}
          matches={
            selectedSeason?.matches.filter((match) =>
              match.match_stage.startsWith("FINAL")
            ) || []
          }
        />
      </div>
    </div>
  );
};

export default Matches;
